import React, { Component } from 'react'
import { CSSTransitionGroup } from 'react-transition-group'
import store from './../../store'

import './Modal.scss'

class Modal extends Component {
    constructor() {
        super()
        this.close_action = 'auto'
        this.scrollpos = 0
    }

    componentDidUpdate(prevProps) {
        if (prevProps.modalOpen !== this.props.modalOpen && this.props.modalOpen) {
            this.close_action = 'auto' //default to auto
            let doc = document.documentElement
            let pos = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

            this.scroll_pos = pos

            document.body.style.position = 'fixed'
            document.body.style.top = '-' + pos + 'px'
            document.body.style.left = 0
            document.body.style.right = 0
        }

        if (prevProps.modalOpen !== this.props.modalOpen && !this.props.modalOpen) {
            let exit_scroll_pos = this.scroll_pos

            document.body.style.position = 'static'
            document.body.style.top = 'auto'
            document.body.style.left = 'auto'
            document.body.style.right = 'auto'

            window.scrollTo(0, exit_scroll_pos)
        }

        if (prevProps.modalOpen !== this.props.modalOpen && this.props.dispatchTypeOnToggle) {
            store.dispatch({
                type: this.props.dispatchTypeOnToggle,
                open: this.props.modalOpen,
                close_action: this.close_action,
            })
        }
    }

    render() {
        const { modalToggle, modalOpen } = this.props

        let active_class = modalOpen ? 'active' : ''

        return (
            <div className="Modal__cont">
                <div
                    className={`background ${active_class}`}
                    onClick={() => {
                        this.close_action = 'manual'
                        modalToggle()
                    }}
                />
                <div className={`content_container ${active_class}`}>
                    <CSSTransitionGroup
                        transitionName="Modal__ani"
                        transitionEnterTimeout={1000}
                        transitionLeaveTimeout={500}
                    >
                        {this.props.children}
                    </CSSTransitionGroup>
                    <div
                        onClick={() => {
                            this.close_action = 'manual'
                            modalToggle()
                        }}
                    >
                        <div className="close_icon">
                            <svg
                                xmlns="https://www.w3.org/2000/svg"
                                x="15px"
                                y="15px"
                                style={{ width: '15px', height: '15px' }}
                                viewBox="18750 -257 14 14"
                            >
                                <path
                                    id="path"
                                    style={{ fill: '#fff', fillRule: 'evenodd' }}
                                    d="M19-17.6,17.6-19,12-13.4,6.4-19,5-17.6,10.6-12,5-6.4,6.4-5,12-10.6,17.6-5,19-6.4,13.4-12Z"
                                    transform="translate(18745 -238)"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Modal
